import React from "react";
import { useSelector } from "react-redux";
import { routePaths } from "services/routing";
import { Header, BackAction, BottomNavigation, Logo } from "shared";
import ProfileSwitcher from "profiles/page/ProfileSwitcher.jsx";
import "./NextSteps.scss";

export default function NextSteps() {

    const { data } = useSelector((state) => state.aiHealthSummary);

    const aiSummary = React.useMemo(() => {
        try {
            if (!data) return null;
            return typeof data === "string" ? JSON.parse(data) : data;
        } catch {
            return null;
        }
    }, [data]);

    const nextSteps = aiSummary?.nextSteps || [];

    const leftElement = <ProfileSwitcher readonly={false} />;
    const backAction = <BackAction to={routePaths.root} />;
    const centerElement = <p className="nextsteps-title">Next Steps</p>;

    return (
        <div className="nextsteps-page">

            <Header
                farLeftElement={backAction}
                leftElement={leftElement}
                centerElement={centerElement}
            />

            <div className="nextsteps-wrapper">
                <div className="nextsteps-container">

                    {nextSteps.length === 0 && (
                        <div className="no-nextsteps">
                            No recommendations available.
                        </div>
                    )}

                    {nextSteps.map((step, index) => (
                        <div className="nextstep-card" key={index}>

                            <div className="card-header">

                                <div className="card-icon">
                                    <Logo />
                                </div>

                                <h3 className="card-title">
                                    {step.programName}
                                </h3>

                            </div>

                            <p className="card-description">
                                {step.recommendationText}
                            </p>

                            <div className="card-footer">
                                <span className="trigger-chip">
                                    {step.recommendationTrigger.replace("_", " ")}
                                </span>
                            </div>

                        </div>
                    ))}

                </div>
            </div>

            <BottomNavigation />

        </div>
    );
}
